const toggleItemsSelection = ({
  selectedItemsMap,
  itemIds,
  shouldSelect,
  folderIds,
  childIdsByParentId,
}) => {
  const nextMap = { ...selectedItemsMap };

  itemIds.forEach((id) => {
    nextMap[id] = shouldSelect;
  });

  const resolveFolder = (folderId) => {
    const childIds = childIdsByParentId[folderId] || [];

    if (!childIds.length) return Boolean(nextMap[folderId]);

    const isSubtreeSelected = childIds.every((childId) =>
      folderIds.has(childId) ? resolveFolder(childId) : Boolean(nextMap[childId])
    );

    nextMap[folderId] = Boolean(nextMap[folderId]) && isSubtreeSelected;

    return nextMap[folderId];
  };

  folderIds.forEach((folderId) => resolveFolder(folderId));

  const hasChanges = Object.keys(nextMap).some(
    (id) => Boolean(nextMap[id]) !== Boolean(selectedItemsMap[id])
  );

  return hasChanges ? nextMap : selectedItemsMap;
};

export default toggleItemsSelection;
